/*
Functions specific to working with contacts and contact lists.
 */

/*
 A compareFn for Array.prototype.sort() of contact lists.

 It ensures that "Muster" lists, like non-geocoded, are first,
 and then all subsequent sorting uses the list names.
 */
export const sortChildContactLists = (a, b) => {
  if (a.isMusterList && !b.isMusterList) {
    return -1;
  }

  if (b.isMusterList && !a.isMusterList) {
    return -1;
  }

  return -b.isMusterList - b.name.localeCompare(a.name, 'en', { numeric: true });
};
